import React from 'react';
import { TrendingUp } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const PrevisionsPage = () => {
  const { t } = useTranslation();
  const p = (key, opts) => t(`modules.achats.pages.previsionsPage.${key}`, opts);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 p-8">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <div className="flex items-center gap-3 mb-2">
            <TrendingUp className="h-8 w-8 text-blue-400" />
            <h1 className="text-3xl font-bold text-white">{p('title')}</h1>
          </div>
          <p className="text-white/60">{p('subtitle')}</p>
        </div>

        <div className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-12 text-center">
          <div className="inline-block p-6 bg-blue-500/10 rounded-full mb-6">
            <TrendingUp className="h-16 w-16 text-blue-400" />
          </div>
          <h2 className="text-2xl font-bold text-white mb-4">{p('card_title')}</h2>
          <p className="text-white/60 text-lg mb-6">
            {p('card_description')}
          </p>
          <div className="inline-flex items-center gap-2 px-6 py-3 bg-blue-500/20 border border-blue-400/30 rounded-xl text-blue-300">
            <span className="animate-pulse">●</span>
            <span>{p('module_in_development')}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrevisionsPage;
